var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EditForm',{attrs:{"parent":_vm.parent,"enfant":_vm.enfant,"default-etablissements":_vm.defaultEtablissements},on:{"reloadEnfants":function($event){return _vm.$emit('reloadEnfants')},"reinitEnfantData":_vm.reinitEnfantData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }